import React from 'react';
import { StyledContent } from '../../styles/mixins'
import {  Tabs } from 'antd';
import { StyledCard } from './style';
import UserProfile from './UserProfile'
import TradeAlerts from './TradeAlerts'
import Subscription from './Subscription'
import Payment from './Payment'
const TabPane = Tabs.TabPane;


class profileContainer extends React.Component {
  
  state = {
    activeTab: this.props.match.params.tab || 'profile'
  }
  
  onTabChange = (activeTab) => {
    this.setState({
      activeTab,
    });
    this.props.history.push('/user-profile/' + activeTab);
  }
  
  render() {
    return (
      <StyledContent>
        <StyledCard title="Profile Settings"  bordered={false}>
          <Tabs defaultActiveKey="profile" activeKey={this.state.activeTab} onChange={this.onTabChange}>
            <TabPane tab="Profile" key={'profile'}>
              <UserProfile />
            </TabPane>
            <TabPane tab="Communication Preferences" key={'communication'}>
              <TradeAlerts />
            </TabPane>
            <TabPane tab="Subscription" key={'subscription'}>
              <Subscription />
            </TabPane>
            <TabPane tab="Payment Information" key={'paymentinformation'}>
              <Payment/>
            </TabPane>
          </Tabs>
        </StyledCard>
      </StyledContent>
    );
  }
}

export default profileContainer



// WEBPACK FOOTER //
// ./src/components/user-profile/index.js